import { string, z } from "zod";
import { isMobilePhone } from "../../../../auth/utils/PhoneNumberValidation";

export function closeForm(setIsOpen) {
  setTimeout(() => {
    setIsOpen(false);
  }, 1000);
}

export function parseClinicDto(data, clinicId) {
  return {
    signUpDto: {
      password: data.password,
      username: data.username,
      firstName: data.firstName,
      lastName: data.lastName,
      phoneNumber: data.phoneNumber,
      email: data.email,
      oib: data.oib?.trim() === "" ? null : data.oib,
    },
    clinic: {
      id: clinicId,
    },
  };
}

export function submitUserToClinicDefault(clinicId) {
  return {
    username: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    password: "",
    oib: "",
    clinic: {
      id: clinicId,
    },
  };
}

export function addUserToClinicResolver(t) {
  return z.object({
    username: string().min(1, { message: t("CantBeEmpty") }),
    firstName: string().min(1, { message: t("CantBeEmpty") }),
    lastName: string().min(1, { message: t("CantBeEmpty") }),
    phoneNumber: z
      .string()
      .min(1, { message: t("CantBeEmpty") })
      .refine((val) => !val || isMobilePhone(val), {
        message: t("InvalidPhoneNumber"),
      }),
    address: string().optional(),
    email: z
      .string()
      .email({ message: t("EmailInvalid") })
      .or(z.literal("")),
    password: string().min(1, { message: t("CantBeEmpty") }),
    oib: z.string().optional(),
  });
}

function isTelephoneNumber(value) {
  // Regex to match a telephone number with optional spaces, dashes, or slashes
  //Takes into account values: 01 1234 123, 01-1234-123, 011234123, 01/1234 123 and combintaions
  const phonePattern = /^(0\d{1})[- /\s]?\d{4}[- /\s]?\d{3}$/;
  return phonePattern.test(value);
}

export function createClinicResolver(t) {
  return z.object({
    clinic: z.object({
      title: z
        .string()
        .min(1, { message: t("CantBeEmpty") })
        .max(120, { message: t("StringToLong") }),
      shortName: z
        .string()
        .min(1, { message: t("CantBeEmpty") })
        .max(20, { message: t("StringToLong") }),
      city: z
        .string()
        .min(1, { message: t("CantBeEmpty") })
        .max(120, { message: t("StringToLong") }),
      zipCode: z
        .string()
        .min(1, { message: t("CantBeEmpty") })
        .max(10, { message: t("ZipCodeTooLong") }),
      streetAddress: z.string().min(1, { message: t("CantBeEmpty") }),
      country: z.string().min(1, { message: t("CantBeEmpty") }),
      phoneNumber: z
        .string()
        .min(1, { message: t("CantBeEmpty") })
        .refine((val) => !val || isMobilePhone(val) || isTelephoneNumber(val), {
          message: t("InvalidPhoneNumber"),
        }),
      email: z
        .string()
        .min(1, { message: t("CantBeEmpty") })
        .refine((val) => !val || z.string().email().safeParse(val).success, {
          message: t("InvalidEmail"),
        }),
      url: z.string().optional(),
      hidden: z.boolean(),
    }),
    username: z.string().min(1, { message: t("CantBeEmpty") }),
    firstName: z.string().min(1, { message: t("CantBeEmpty") }),
    lastName: z.string().min(1, { message: t("CantBeEmpty") }),
    phoneNumber: z
      .string()
      .min(1, { message: t("CantBeEmpty") })
      .refine((val) => !val || isMobilePhone(val), {
        message: t("InvalidPhoneNumber"),
      }),
    oib: z.string().optional(),
  });
}

export function editClinicResolver(t) {
  return z.object({
    clinic: z.object({
      title: z.string().min(1, { message: t("CantBeEmpty") }),
      shortName: z
        .string()
        .min(1, { message: t("CantBeEmpty") })
        .max(20, { message: t("StringToLong") }),
      city: z.string().min(1, { message: t("CantBeEmpty") }),
      zipCode: z
        .string()
        .min(1, { message: t("CantBeEmpty") })
        .max(9, { message: t("ZipCodeTooLong") })
        .refine(
          (val) => /^\d+$/.test(val), // Ensure it only contains digits
          { message: t("MustBeNumeric") }
        ),
      streetAddress: z.string().min(1, { message: t("CantBeEmpty") }),
    }),
  });
}
